const REDIRECT_GUARD_KEY = "japan_conflux_pending_payment_redirect";
const REDIRECT_GUARD_TTL = 30 * 60 * 1000;

function normalizeValue(value) {
  if (value === null || typeof value === "undefined") return "";
  return `${value}`.trim();
}

export function normalizeJapanPendingPaymentQuery(query = {}) {
  const normalizedQuery = {
    pendingPay: "1",
    orderCode: normalizeValue(query.orderCode),
    orderNumber: normalizeValue(query.orderNumber || query.flowOrderNo || query.id),
    payOrderCode: normalizeValue(query.payOrderCode || query.merchantOrderNo || query.payOrderNo),
    email: normalizeValue(query.email),
    mobile: normalizeValue(query.mobile || query.mobileNo),
    payCancel: normalizeValue(query.payCancel),
    payFailed: normalizeValue(query.payFailed),
    paymentMethodCode: normalizeValue(query.paymentMethodCode),
  };

  return Object.entries(normalizedQuery).reduce((result, [key, value]) => {
    if (value) result[key] = value;
    return result;
  }, {});
}

export function hasJapanPendingPaymentIdentity(query = {}) {
  return Boolean(
    query.orderCode
    || query.orderNumber
    || query.payOrderCode
    || query.email
    || query.mobile
  );
}

export function saveJapanPendingPaymentRedirect(query = {}, targetPath = "/payment") {
  if (!process.client) return;

  const normalizedQuery = normalizeJapanPendingPaymentQuery(query);
  if (!hasJapanPendingPaymentIdentity(normalizedQuery)) return;

  try {
    localStorage.setItem(REDIRECT_GUARD_KEY, JSON.stringify({
      targetPath,
      query: normalizedQuery,
      createdAt: Date.now(),
    }));
  } catch (error) {
    // Storage is best-effort; direct router navigation still carries the same query.
  }
}

export function readJapanPendingPaymentRedirect() {
  if (!process.client) return null;

  try {
    const rawValue = localStorage.getItem(REDIRECT_GUARD_KEY);
    if (!rawValue) return null;

    const payload = JSON.parse(rawValue);
    const createdAt = Number(payload?.createdAt || 0);
    if (!createdAt || Date.now() - createdAt > REDIRECT_GUARD_TTL) {
      localStorage.removeItem(REDIRECT_GUARD_KEY);
      return null;
    }

    const query = normalizeJapanPendingPaymentQuery(payload?.query || {});
    if (!hasJapanPendingPaymentIdentity(query)) {
      localStorage.removeItem(REDIRECT_GUARD_KEY);
      return null;
    }

    return {
      targetPath: normalizeValue(payload?.targetPath) || "/order/query",
      query,
    };
  } catch (error) {
    try {
      localStorage.removeItem(REDIRECT_GUARD_KEY);
    } catch (storageError) {
      // Ignore nested storage failures.
    }
    return null;
  }
}

export function clearJapanPendingPaymentRedirect() {
  if (!process.client) return;

  try {
    localStorage.removeItem(REDIRECT_GUARD_KEY);
  } catch (error) {
    // Ignore storage cleanup failures.
  }
}

